var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.clazz,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},_vm._l((_vm.icon.paths),function(path,index){return _c('path',{key:index,attrs:{"d":path.d,"fill":path.fill,"stroke":path.stroke}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }